export default "__VITE_ASSET__Thgo73zh__";